(function () {
    'use strict';

    const module = angular.module('imApp');

    module.component('productBom', {
        templateUrl: 'views/components/views/productBom/productBom.template.html?v=' + module.version,
        controllerAs: 'vm',
        controller: ['$stateParams', 'stateService', 'utilityService', 'translateService', 'modalService', 'productBomService', 'ttGridFactory', 'rememberService', 'fileService', function ($stateParams, stateService, utilityService, translateService, modalService, productBomService, ttGridFactory, rememberService, fileService) {

            // #region VARIABLES & DEFINITIONS

            const vm = this;
            let prodId = $stateParams.prod_id;

            let selectedProductBom = {
                bom_verified: '0'
            };

            let variableNames = {
                prod_id_selected: '',
                gb_productbom_list: ''
            };

            let translations = {
                error: '',
                ok: ''
            };

            let style = {
                container: {},
                img: {},
                placeholder: {}
            };

            vm.model = {
                prodId: prodId,
                gridComponentsReady: false,
                gridOperationsReady: false,
                bgProductBomList: {
                    selected: 'COMPONENT',
                    buttons: [
                        { id: 'COMPONENT', label: 'gb_productbom_list_component', color: 'primary', onClick: () => setProductBomListView('COMPONENT') },
                        { id: 'WORK', label: 'gb_productbom_list_work', color: 'primary', onClick: () => setProductBomListView('WORK') },
                        { id: 'OTHER', label: 'gb_productbom_list_other', color: 'primary', onClick: () => setProductBomListView('OTHER') },
                        { id: 'DOCUMENTS', label: 'documents_documents', color: 'primary', onClick: () => setProductBomListView('DOCUMENTS') },
                        { id: 'PICTURES', label: 'documents_pictures', color: 'primary', onClick: () => setProductBomListView('PICTURES') },
                        { id: 'VIDEOS', label: 'documents_videos', color: 'primary', onClick: () => setProductBomListView('VIDEOS') }
                    ]
                },
                productSelectedButtons: [{ id: 'goto', icon: 'fa fa-chevron-right', color: 'primary', type: 'primary', onClick: () => stateService.go('product', { prod_id: vm.model.setting.prod_keyno_selected }) }],
                setting: {},
                treeListProductBoms: [],
                itemsListIncludedIn: [],
                selectListAssemblyGroups: [],
                itemsListOwns: [],
                itemsListDocuments: [],
                itemsListPictures: [],
                itemsListVideos: [],
                checkingError: false
            };

            vm.gridComponents = new ttGridFactory({
                rememberId: 'w_productbom_components',
                kendo: {
                    height: '700px',
                    sortable: true,
                    aggregate: true,
                    pager: false,
                    selectable: false,
                    filterable: false
                }
            }).setCustomToolbarButtons([{
                name: 'components_add',
                text: 'components_add',
                func: () => {
                    stateService.go('component', {
                    	prod_id: vm.model.setting.prod_keyno_selected,
                    	comp_keyno: '0'
                    });
                },
                icon: 'fa-plus',
                cssClass: 'btn btn-primary im-grid-btn-xs-r',
                translate: true
            }]).setToggleButtons([{
                name: 'test',
                text: 'test',
                state: 0,
                states: [
                    { text: 'bom_verified_unchecked', func: function () { verifyBom(0) }, icon: 'fal fa-square' },
                    { text: 'bom_verified_checked', func: function () { verifyBom(1) }, icon: 'fal fa-check-square' }
                ],
                cssClass: 'tt-grid-btn-xs tt-button--primary',
                icon: 'fal fa-ballot-check',
                disabled: function () { return false; }
            }]);
            
            vm.gridOperations = new ttGridFactory({
                rememberId: 'w_productbom_operations',
                kendo: {
                    height: '700px',
                    sortable: true,
                    aggregate: true,
                    pager: false,
                    selectable: false,
                    filterable: false
                }
            }).setCustomToolbarButtons([
                {
                    name: 'productbom_work_new',
                    text: 'productbom_work_new',
                    func: () => {
                        stateService.go('work', {
                            prod_id: vm.model.setting.prod_keyno_selected,
                            work_keyno: '0'
                        });
                    },
                    icon: 'fa-plus',
                    cssClass: 'btn btn-primary im-grid-btn-xs-r',
                    translate: true
                },
                {
                    name: 'productbom_productionroutingadd',
                    text: 'productbom_productionroutingadd',
                    func: () => stateService.go('productionroutingadd', { prod_id: vm.model.setting.prod_keyno_selected }),
                    icon: 'fa-plus',
                    cssClass: 'btn btn-primary im-grid-btn-xs-r',
                    translate: true
                }
            ]);

            // #endregion VARIABLES & DEFINITIONS

            // #region TRANSLATION FUNCTION

            async function translate() {
                let data = await translateService.translateBatch(translations);

                Object.keys(translations).forEach((key) => {
                    if (data?.[key]) translations[key] = data[key];
                });
            }

            // #endregion TRANSLATION FUNCTION

            // #region LOAD PROCEDURE CALLS

            async function loadSetting() {
                vm.model.setting = (await productBomService.getSetting({ prod_id: prodId }))[0];
            }

            async function loadAssemblyGroups() {
                vm.model.selectListAssemblyGroups = await productBomService.listAssemblyGroups();
            }
            
            async function loadOwns() {
                return vm.model.itemsListOwns = await productBomService.listOwns(vm.model.setting);
            }

            async function loadIncludedIn() {
                if (utilityService.validateParmsValue(vm.model.setting.prod_id_selected) !== true) return;

                return vm.model.itemsListIncludedIn = await productBomService.listIncludedIn({ prod_id: vm.model.setting.prod_id_selected });
            }

            async function loadProductBoms() {
                if (utilityService.validateParmsValue(vm.model.setting.prod_id) !== true) return;

                return vm.model.treeListProductBoms = await productBomService.listProductBoms({ prod_id: vm.model.setting.prod_id });

                selectedProductBom = vm.model.treeListProductBoms.find(item => item.item_id === vm.model.setting.prod_id_selected);

                if (selectedProductBom?.bom_verified && (selectedProductBom.bom_verified === '1' || selectedProductBom.bom_verified === 1)) vm.gridComponents.config.toolbar.toggles[0].state = 1;
                else vm.gridComponents.config.toolbar.toggles[0].state = 0;
            }

            async function loadDocuments(id) {
                if (utilityService.validateParmsValue(vm.model.setting.prod_keyno_selected) !== true) return;

                switch (id) {
                    case 'DOCUMENTS':
                        vm.model.itemsListDocuments = await productBomService.listDocuments({
                            argtype: 'prod_id',
                            argvalue: vm.model.setting.prod_keyno_selected,
                            searchtext: '',
                            doctype: 'd',
                            onlyFilenames: '0',
                        });
                        break;
                    case 'PICTURES':
                        vm.model.itemsListPictures = await productBomService.listDocuments({
                            argtype: 'prod_id',
                            argvalue: vm.model.setting.prod_keyno_selected,
                            searchtext: '',
                            doctype: 'p',
                            onlyFilenames: '0',
                        });
                        break;
                    case 'VIDEOS':
                        vm.model.itemsListVideos = await productBomService.listDocuments({
                            argtype: 'prod_id',
                            argvalue: vm.model.setting.prod_keyno_selected,
                            searchtext: '',
                            doctype: 'v',
                            onlyFilenames: '0',
                        });
                        break;
                    default:
                        break;
                }
            }

            async function retrieveProdIdSelected() {
                if (utilityService.validateParmsValue(vm.model.setting.prod_id_selected) !== true) return;

                const response = (await productBomService.getProdIdSelected({ prod_id_selected: vm.model.setting.prod_id_selected }))[0];

                vm.model.setting.prod_name_selected = response?.prod_name_selected;
                vm.model.setting.prod_keyno_selected = response?.prod_keyno_selected;
                vm.model.setting.url_picture = response?.url_picture;
                vm.model.setting.product_main_image = response?.product_main_image;
                vm.model.setting.assemblygroup_id = response?.assemblygroup_no;
                
                // Load product image
                let productMainImage = vm.model.setting.product_main_image;

                if (typeof (productMainImage) === 'string' && productMainImage !== '') {
                    fileService.getFileInfo({
                        selectOnlyFromFiles: true,
                        files: [{
                            "fileName": productMainImage
                        }]//,
                        //page: 1,
                        //pageSize: 1
                    }).then(function (result) {
                        if (typeof (result) === 'object' && "files" in result && result.files.length > 0) {
                            // We only want first image for the first version of this feature
                            var fileData = result.files[0];
                            var thumbUrl = fileData.thumbUrl;

                            var decoded = decodeURIComponent(thumbUrl);
                            var qsIndex = decoded.indexOf('{');
                            var url = decoded.substr(0, qsIndex);
                            var qs = decoded.substr(qsIndex);

                            qs = qs.substr(0, qs.indexOf(',"width"')) + ',"width":133,"height":100}';
                            qs = encodeURIComponent(qs);

                            // Insert link to image for use in HTML
                            vm.model.setting.productImageUrl = url + qs;
                        }
                    });
                }
            }

            function verifyBom(state) {
                if (utilityService.validateParmsValue(vm.model.setting.prod_id_selected) !== true) return;
                
                selectedProductBom.bom_verified = state;

                return productBomService.updateBom({
                    prod_id: vm.model.setting.prod_id_selected,
                    bom_verified: state
                });
            }

            function updateAssemblyGroup(assemblyGroupId) {
                if (utilityService.validateParmsValue(vm.model.setting.prod_id_selected) !== true) return;

                vm.model.setting.assemblygroup_id = assemblyGroupId;

                return productBomService.saveAssemblyGroup({
                    prod_id: vm.model.setting.prod_id_selected,
                    assemblygroup_no: assemblyGroupId
                });
            }

            // #endregion LOAD PROCEDURE CALLS

            // #region GRID PROCEDURE FUNCTION CALLS

            async function loadGridComponents() {
                if (utilityService.validateParmsValue(vm.model.setting.prod_id_selected) !== true) return;

                vm.gridComponents.dataTask.loadData = {
                    method: 2479,
                    parameters: { prod_id: vm.model.setting.prod_id_selected }
                };

                if (vm.model.bgProductBomList.selected === 'COMPONENT') vm.model.gridComponentsReady = true;

                if (vm.gridComponents.gridfunc !== null) vm.gridComponents.gridfunc.read();
            }

            async function loadGridOperations() {
                if (utilityService.validateParmsValue(vm.model.setting.prod_id_selected) !== true) return;

                vm.gridOperations.dataTask.loadData = {
                    method: 2312,
                    parameters: { prod_id: vm.model.setting.prod_id_selected }
                };

                if (vm.model.bgProductBomList.selected === 'WORK') vm.model.gridOperationsReady = true;
                if (vm.gridOperations.gridfunc !== null) vm.gridOperations.gridfunc.read();
            }

            // #endregion GRID PROCEDURE FUNCTION CALLS

            // #region REMEMBER VALUE MULTI PROCEDURE FUNCTION CALLS

            function rememberFunc(id) {
                Object.keys(variableNames).forEach((key) => {
                    switch (key) {
                        case 'prod_id_selected':
                            variableNames[key] = 'w_' + stateService.getCurrentName() + '.' + vm.model.setting.prod_id;
                            break;
                        case 'gb_productbom_list':
                            variableNames[key] = 'w_' + stateService.getCurrentName() + '.' + 'gb_productbom_list' + '.' + vm.model.setting.prod_id;
                            break;
                        default:
                            variableNames[key] = 'w_' + stateService.getCurrentName() + '.' + key;
                            break;
                    }
                });

                if (utilityService.validateParmsValue(variableNames[id]) !== true) return;

                let variableValue = null;

                switch (id) {
                    case 'prod_id_selected':
                    case 'gb_productbom_list':
                        if (utilityService.validateParmsValue(vm.model.setting[id]) !== true) return;

                        variableValue = vm.model.setting[id];
                        break;
                    default:
                        break;
                }

                return rememberService.remember(variableNames[id], variableValue);
            }

            // #endregion REMEMBER VALUE MULTI PROCEDURE FUNCTION CALLS

            // #region CHECK BUTTON FUNCTION

            vm.checkError = function () {
                vm.model.checkingError = true;

                productBomService.checkProduct({ prod_id: vm.model.setting.prod_id }).then(function (response) {
                    if (response[0].errorcode !== '0') {
                        modalService.show({
                            type: 'warning',
                            title: translations.error,
                            message: response[0].errormessage,
                            buttons: [{
                                label: translations.ok,
                                cssClass: 'btn-warning',
                                action: function (dialogItself) {
                                    dialogItself.close();
                                    vm.model.checkingError = false;
                                }
                            }]
                        });
                    } else {
                        vm.model.checkingError = false;
                    }
                });
            }

            // #endregion CHECK BUTTON FUNCTION

            // #region SET IMAGE HEIGHT FUNCTION

            function setImageHeight() {
                setTimeout(() => {
                    let fieldsDiv = document.querySelector('.productbom__fields');
                    let firstChild = fieldsDiv?.children?.[0];

                    if (firstChild) {
                        style.container.marginBottom = '0';
                        style.img.minHeight = `70px`;
                        style.placeholder.minHeight = `70px`;
                        style.img.height = `${firstChild.clientHeight - (10.111 * 4 + 7)}px`;
                        style.placeholder.height = `${firstChild.clientHeight - (10.111 * 4 + 7)}px`;

                        style = { ...style };
                    }
                }, 50);
            }

            // #endregion SET IMAGE HEIGHT FUNCTION

            // #region BUTTON GROUP SINGLE FUNCTION

            async function setProductBomListView(id) {
                vm.model.bgProductBomList.selected = vm.model.setting.gb_productbom_list = id;
            }

            // #endregion BUTTON GROUP SINGLE FUNCTION

            // #region BUTTON GROUP FUNCTIONS

            vm.selectBgProductBomList = async function (item) {
                vm.model.bgProductBomList.selected = item;
                vm.model.setting.gb_productbom_list = vm.model.bgProductBomList.selected;

                if (utilityService.validateParmsValue(vm.model.setting.prod_id_selected) === true && vm.model.bgProductBomList.selected === 'COMPONENT') vm.model.gridComponentsReady = true;
                if (utilityService.validateParmsValue(vm.model.setting.prod_id_selected) === true && vm.model.bgProductBomList.selected === 'WORK') vm.model.gridOperationsReady = true;

                await rememberFunc('gb_productbom_list');
                if (vm.model.bgProductBomList.selected === 'DOCUMENTS' || vm.model.bgProductBomList.selected === 'PICTURES' || vm.model.bgProductBomList.selected === 'VIDEOS') loadDocuments(vm.model.bgProductBomList.selected);
            }

            // #endregion BUTTON GROUP FUNCTIONS

            // #region TREE SELECTION FUNCTION

            vm.selectTreeItem = async function (item) {
                selectedProductBom = item;
                vm.model.setting.prod_id_selected = item.item_id;

                if (selectedProductBom?.bom_verified && (selectedProductBom.bom_verified === '1' || selectedProductBom.bom_verified === 1)) vm.gridComponents.config.toolbar.toggles[0].state = 1;
                else vm.gridComponents.config.toolbar.toggles[0].state = 0;

                await Promise.all([rememberFunc('prod_id_selected'), retrieveProdIdSelected()]);
                loadGridComponents();
                loadGridOperations();
                loadIncludedIn();
                setImageHeight();

                if (vm.model.bgProductBomList.selected === 'COMPONENT' && vm.model.gridComponentsReady === true) loadGridComponents();
                if (vm.model.bgProductBomList.selected === 'WORK' && vm.model.gridOperationsReady === true) loadGridOperations();
                if (vm.model.bgProductBomList.selected === 'DOCUMENTS' || vm.model.bgProductBomList.selected === 'PICTURES' || vm.model.bgProductBomList.selected === 'VIDEOS') loadDocuments(vm.model.bgProductBomList.selected);
            }

            // #endregion TREE SELECTION FUNCTION

            // #region FIELD CHANGE MULTI FUNCTIONS

            vm.onChanged = function (value, id) {
                switch (id) {
                    case 'assemblygroup_id':
                        if (utilityService.validateWatchValue(value, vm.model.setting.assemblygroup_id) !== true) return;

                        vm.model.setting.assemblygroup_id = value;

                        if (utilityService.validateParmsValue(vm.model.setting.assemblygroup_id) !== true) return;

                        updateAssemblyGroup(vm.model.setting.assemblygroup_id);
                        break;
                    default:
                        utilityService.setValueToVariable(value);
                        break;
                }
            };

            // #endregion FIELD CHANGE MULTI FUNCTIONS

            // #region ON INIT FUNCTION

            vm.$onInit = async function () {
                translate();
                await loadSetting();
                await Promise.all([setProductBomListView(vm.model.setting.gb_productbom_list), loadProductBoms()]);
                loadGridOperations();
                loadGridComponents();
                loadIncludedIn();
                loadOwns();
                retrieveProdIdSelected();
                loadAssemblyGroups();

                if (vm.model.bgProductBomList.selected === 'DOCUMENTS' || vm.model.bgProductBomList.selected === 'PICTURES' || vm.model.bgProductBomList.selected === 'VIDEOS') loadDocuments(vm.model.bgProductBomList.selected);

                setImageHeight();
            }

            // #endregion ON INIT FUNCTION

        }]
    });
})();
